import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import DataPage from "./components/DataPage";
import OrderPage from "./components/OrderPage";
import OrderDetailPage from "./components/OrderDetailPage";
import { OrderDetailsProvider } from "./contexts/orderDetails";
import Login from "./Login";
import NotificationPage from "./components/NotificationPage";
import PageNotFound from "./components/404";
import AddOrderPage from "./components/AddOrder";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <DataPage />,
      },{
        path: "/add-order",
        element: <AddOrderPage />,

      },
      {
        path: "/order/:pageNo",
        element: <OrderPage />,
      },
      {
        path: "/order-filter/:pageNo",
        element: <OrderPage />,
      },
      {
        path: "order-details/:orderId",
        element: (
          <OrderDetailsProvider>
            <OrderDetailPage />
          </OrderDetailsProvider>
        ),
      },
      {
        path: "/notification",
        element: <NotificationPage />,
      },
      {
        path: "/history/:pageNo",
        element: <OrderPage />,
      },
      {
        path: "/history-filter/:pageNo",
        element: <OrderPage />,
      },
      {
        path: "login",
        element: <Login />,
      },
    ],
    errorElement: <PageNotFound />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
